import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------credit api's-------------------------------->
    /**
     * get tax index page
     * @param {} page 
     * @param {*} count 
     * @param {*} search 
     * @param {*} status 
     */
    getTaxes(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/tax')
    },
    /**
     * get tax details 
     */
    getDetails(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/tax/details')
    },
    posttaxrate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/tax/createtaxrate', data)
    },
    posttaxgroup(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/tax/createtaxgroup', data)
    },
    postupdatetaxrate(id, data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/tax/updatetaxrate/' + id, data)
    },
    postupdatetaxgroup(id, data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/tax/updatetaxgroup/' + id, data)
    },
    getviewtaxrate(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/tax/viewtaxrate/' + id)
    },
    getviewtaxgroup(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/tax/viewtaxgroup/' + id)
    },
    deletetaxrate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/tax/singletaxratedelete', data)
    },
    deletetaxgroup(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/tax/singletaxgroupdelete', data)
    }
}